import Box from '@mui/material/Box';
import type { WizardStepDefinition } from '../../types';

const StepWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <Box>{children}</Box>;
};

export const Step: React.FC<WizardStepDefinition> = ({
  component: Component,
  titleElement,
  onNext,
  onPrevious,
  recommendationId,
  onUpdateValues,
}) => {
  return (
    <StepWrapper>
      {titleElement}
      <Component
        onNext={onNext}
        onPrevious={onPrevious}
        recommendationId={recommendationId}
        onUpdateValues={onUpdateValues}
      />
    </StepWrapper>
  );
};
